import { 
  useEffect, 
  useState, 
  Suspense,
  Profiler,
  useCallback,
} from 'react';

import {
  debounce,
} from "lodash";

import {
  Spin,
  message,
} from "antd";

import {
  useRoutes, 
  useLocation,
  Route,
  useNavigate,
} from "react-router-dom";

import route from "./route";

import './App.css';

const App = () =>{
  let element = useRoutes(route);
  let location = useLocation();
  let linkRoute = useNavigate();
  const [viewPortWidth, setViewPortWidth] = useState(0);
  const [viewPortHeight, setViewPortHeight] = useState(0);
  const viewPortWidthPrior = useCallback(debounce(setViewPortWidth, 600), []);
  const viewPortHeightPrior = useCallback(debounce(setViewPortHeight, 600), []);
  
  /**
   * 
   * 测试组件渲染的性能
   */
  const onRender = (id: string, phase: string, actualDuration: any, baseDuration: any, startTime: any, endTime: any) =>{
    // console.log(actualDuration);
    // console.log(baseDuration);
    
  };

  /**
   * 
   * 获取视口高度
   */
  const getViewPort = () => {
    viewPortWidthPrior(window.innerWidth);
    viewPortHeightPrior(window.innerHeight);
  };

  /**
   * 
   * 路由重定向(是否登录)
   */
  const routeRedirect = () =>{
    // 不需要登录就能看到的页面
    const noAuthPage = ["/login", "/register", "/code-test"];
    if(!(noAuthPage.includes(location.pathname))) {
      let userName = window.sessionStorage.getItem("userName");
      if(!userName) {
        message.info("用户未登录");
        linkRoute("/login");
      }
    }
  };

  useEffect(() =>{
    getViewPort();
  }, []);

  useEffect(() =>{
    window.addEventListener("resize", () =>{getViewPort();})
    return window.removeEventListener("resize", () =>{getViewPort()})
  }, []);

  useEffect(() =>{
    routeRedirect();
  }, [location.pathname])
  return (
    <Profiler id="app" onRender={onRender}>
      <div className='App' style={{width: viewPortWidth, height: viewPortHeight}}>
        <Suspense fallback={<div className="route-loading" ><Spin /></div>}>
            {element}
        </Suspense>
      </div>
    </Profiler>
    
  );
}

export default App;
